module.exports = __webpack_public_path__ + "img/carolina.1f44d839.jpeg";